import { ISurveyHeader } from "../common/data/dtos/survey-header";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/SurveyHeader';

interface SurveyHeaderResponse {
    success: boolean;
    surveyHeader?: ISurveyHeader;
    surveyHeaders?: ISurveyHeader[];
    error?: string;
}

type CreateSurveyHeaderType = Omit<ISurveyHeader, 'id'> | Partial<ISurveyHeader>;

const createSurveyHeader = async (surveyHeader: CreateSurveyHeaderType): Promise<SurveyHeaderResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ISurveyHeader>(`${BASE_PATH}`, surveyHeader);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteSurveyHeader = async (id: string): Promise<SurveyHeaderResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ISurveyHeader>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveyHeaders = async (): Promise<SurveyHeaderResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyHeader>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyHeaders: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneSurveyHeader = async (id: string): Promise<SurveyHeaderResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyHeader>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyHeader: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateSurveyHeader = async (surveyHeader: ISurveyHeader): Promise<SurveyHeaderResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<ISurveyHeader>(`${BASE_PATH}/${surveyHeader.id}`, surveyHeader);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveyHeaderBySurvey = async (id: string): Promise<SurveyHeaderResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurveyHeader>(`${BASE_PATH}/GetBySurvey?id=${id}`);
        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveyHeaders: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createSurveyHeader,
    deleteSurveyHeader,
    getSurveyHeaders,
    getOneSurveyHeader,
    updateSurveyHeader,
    getSurveyHeaderBySurvey
};